// extracted by mini-css-extract-plugin
export default {"messageValueContainer":"styles_messageValueContainer__iM-sU","messageValue":"styles_messageValue__OoTdc","titleText":"styles_titleText__M60RD"};